export interface PetNeeds {
  hunger: number;
  mood: number;
  energy: number;
}

export type PetAction = 'feed' | 'play' | 'rest';

export type PetSpecies = 'shark_pup' | 'elephant_calf' | 'gorilla_infant' | 'wolf_pup';

export interface PetSnapshot {
  active: boolean;
  enabled: boolean;
  notifications_enabled: boolean;
  species: PetSpecies | null;
  needs: PetNeeds | null;
  last_updated_at: string | null;
  cooldowns: Record<PetAction, number>;
}

export const PET_SPECIES: Record<PetSpecies, { label: string; emoji: string; accent: string }> = {
  shark_pup: { label: 'Акулёнок', emoji: '🦈', accent: 'shark-accent-text' },
  elephant_calf: { label: 'Слонёнок', emoji: '🐘', accent: 'shark-accent-text' },
  gorilla_infant: { label: 'Детёныш гориллы', emoji: '🦍', accent: 'shark-accent-text' },
  wolf_pup: { label: 'Волчонок', emoji: '🐺', accent: 'shark-accent-text' },
};
